<div class="w-full max-w-5xl mx-auto sm:min-h-screen
            bg-white md:rounded-lg md:shadow-lg md:p-6
            p-4 flex flex-col">

  <div class="relative flex items-center justify-center text-center">
  <!-- Botón a la izquierda -->
  <button class="absolute left-0" (click)="goBack()">
    <app-metro-icon [svg]="iconBack" size="20" color="#0e161b"></app-metro-icon>
  </button>

  <h2 class="text-lg font-semibold break-words max-w-[80%]">
    {{wine?.name}}
  </h2>
</div>


  <div class="w-full h-[20vh] flex justify-center items-center mb-6 relative">
    @if (wine || hasError){
    <img [src]="wine?.imageUrl"
      class="w-full h-full object-contain rounded-lg transition-opacity duration-700" (load)="imageLoaded = true"
      (error)="onImageError($event)" [class.opacity-0]="!imageLoaded" [class.opacity-100]="imageLoaded" />
    }
    <!-- Skeleton -->
    @else {
    <div class="absolute inset-0 bg-gray-200 animate-pulse rounded-lg"></div>
    }

  </div>

  <div class="mb-4">
    <h2 class="text-lg  text-metro-blue-secondary font-bold uppercase tracking-wide">{{ wine?.name }}</h2>
    <span></span>$ {{ wine?.price | number:'1.2-2'}}
    <!-- winepassport#364 (WP-018) — la ficha del vino agotado sigue siendo accesible, solo se marca. -->
    @if (isOutOfStock) {
    <span class="inline-block ml-2 bg-red-100 text-red-700 px-2 py-0.5 rounded font-semibold text-xs align-middle">{{'::Catalog:OutOfStockBadge' | abpLocalization}}</span>
    }
  </div>

  <div class="grid grid-cols-2 md:grid-cols-3 gap-4 ">
    <div class="flex flex-col items-start border-b border-gray-200">
      <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Winery' | abpLocalization }}</span>
      <span class="text-sm font-medium">{{ wine?.wineryName }}</span>
    </div>

    <div class="flex flex-col items-start  border-b border-gray-200">
      <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Type' | abpLocalization }}</span>
      <span class="text-sm font-medium">{{ wine?.type }}</span>
    </div>

    <div class="flex flex-col items-start border-b border-gray-200">
      <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Varietal' | abpLocalization }}</span>
      <span class="text-sm font-medium">{{ wine?.varietal }}</span>
    </div>

    @if (wine?.harvest) {
      <div class="flex flex-col items-start border-b border-gray-200">
        <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Harvest' | abpLocalization }}</span>
        <span class="text-sm font-medium">{{ wine?.harvest }}</span>
      </div>
    }

    <div class="flex flex-col items-start border-b border-gray-200">
      <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Country' | abpLocalization}}</span>
      <div class="flex items-center gap-1">
        @if (wine?.wineryCountry) {
        <img [src]="'assets/images/flags/' + getCountryCode(wine?.wineryCountry) + '.svg'" alt="{{ wine?.wineryCountry }}"
          class="w-4 h-4 rounded-full object-cover">
        }
        <span class="text-sm font-medium">{{ wine?.wineryCountry }}</span>

      </div>
    </div>

    <div class="flex flex-col items-start border-b border-gray-200">
      <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Region' | abpLocalization }}</span>
      <span class="text-sm font-medium">{{ wine?.wineryRegion }}</span>
    </div>

    </div>

  <div class="flex flex-col items-start mt-3">
    <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Description' | abpLocalization}}</span>
    <span class="text-sm font-medium">{{ wine?.description }}</span>
  </div>
  @if (isOutOfStock) {
  <!-- winepassport#364 (WP-018) — "Avisame cuando vuelva" reemplaza al botón de compra. -->
  <div class="mt-4 w-full max-w-md mx-auto">
    @if (notifyRestockResult === 'success') {
    <p class="text-sm text-green-700">{{'::Catalog:NotifyMeSuccess' | abpLocalization}}</p>
    } @else if (notifyRestockResult === 'already-subscribed') {
    <p class="text-sm text-metro-blue-secondary">{{'::Catalog:NotifyMeAlreadySubscribed' | abpLocalization}}</p>
    } @else {
    <div class="flex flex-row items-center gap-2">
      <input type="email" [(ngModel)]="notifyEmail" [readonly]="hasLoggedIn"
        [placeholder]="'::Catalog:NotifyMeEmailPlaceholder' | abpLocalization"
        class="flex-1 min-w-0 border rounded-md px-3 py-2 text-sm focus:outline-none"
        [class.bg-gray-100]="hasLoggedIn" />
      <app-metro-button [text]='"::Catalog:NotifyMeSubmit" | abpLocalization' [disabled]="notifyingRestock || !notifyEmail?.trim()"
        (click)="subscribeToRestock()">
      </app-metro-button>
    </div>
    @if (notifyRestockResult === 'error') {
    <p class="text-sm text-red-600 mt-1">{{'::Catalog:NotifyMeError' | abpLocalization}}</p>
    }
    }
  </div>
  } @else if (hasLoggedIn) {
  <div class="flex flex-row items-center gap-2 mt-4 w-full max-w-md mx-auto">

    <div class="flex items-center gap-2 flex-shrink-0">
      <button class="px-2 py-1.5 rounded-md bg-metro-blue text-metro-secondary"
        (click)="decreaseQuantity()">-</button>

      <input type="number" [value]="quantity" (input)="onQuantityChange($event)" min="1" [max]="maxQuantity"
        class="w-12 text-center focus:outline-none no-spinners ">

      <button class="px-2 py-1.5 rounded-md bg-metro-blue text-metro-secondary"
        (click)="increaseQuantity()">+</button>
    </div>

    <div class="flex-1 min-w-0">
      <app-metro-button class="w-full" [text]='"::AddToCart" | abpLocalization' (click)="onAddToCart()">
      </app-metro-button>
    </div>
  </div>

  }@else{
  <div class="flex flex-row items-center gap-2 mt-4 w-full max-w-md mx-auto">
    <div class="flex-1 min-w-0">
      <app-metro-button class="w-full" [text]='"::Buy" | abpLocalization' (click)="goRegister()">
      </app-metro-button>
    </div>
  </div>

  }



</div>
